export default "__VITE_ASSET__BXIMu$2A__"